const DOTS = [
  { cx: 240.76, cy: 153.46, r: 3.57, size: "large" },
  { cx: 445.1, cy: 436.42, r: 2.73, size: "medium" },
  { cx: 279.34, cy: 291.31, r: 2.73, size: "medium" },
  { cx: 403.82, cy: 349.94, r: 2.73, size: "medium" },
  { cx: 422.37, cy: 114.86, r: 2.73, size: "small" },
  { cx: 215.98, cy: 249.19, r: 2.73, size: "small" },
  { cx: 337.37, cy: 213.61, r: 2.73, size: "small" },
  { cx: 316.55, cy: 127.15, r: 2.73, size: "small" },
  { cx: 250.3, cy: 371.23, r: 2.73, size: "small" },
  { cx: 340.12, cy: 419.4, r: 2.73, size: "small" },
  { cx: 226.73, cy: 445.71, r: 2.73, size: "small" },
  { cx: 208.21, cy: 508.11, r: 2.73, size: "small" },
  { cx: 210.88, cy: 641.28, r: 2.73, size: "small" },
  { cx: 463.66, cy: 317.64, r: 2.73, size: "small" },
  { cx: 475.01, cy: 389.76, r: 2.73, size: "small" },
] as const;

function MapDots() {
  return (
    <svg
      viewBox="27.16 0 550.4 704.77"
      className="absolute inset-0 w-full h-full"
    >
      <style>{`
        .dot { fill: #7eb3ff }
        .pulse-outer, .pulse-inner {
          fill: #7eb3ff;
          opacity: 0;
          transform-box: fill-box;
          transform-origin: center;
          animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);
          animation-iteration-count: infinite;
        }
        .pulse-outer-large { animation: po-lg 2s infinite }
        .pulse-inner-large { animation: pi-lg 2s infinite }
        .pulse-outer-medium { animation: po-md 2s infinite }
        .pulse-inner-medium { animation: pi-md 2s infinite }
        .pulse-outer-small { animation: po-sm 2s infinite }
        .pulse-inner-small { animation: pi-sm 2s infinite }

        @keyframes po-lg { 0% { transform: scale(1); opacity: 0.32 } 100% { transform: scale(18.5); opacity: 0 } }
        @keyframes pi-lg { 0% { transform: scale(1); opacity: 0.55 } 100% { transform: scale(9.8); opacity: 0 } }
        @keyframes po-md { 0% { transform: scale(1); opacity: 0.25 } 100% { transform: scale(20.1); opacity: 0 } }
        @keyframes pi-md { 0% { transform: scale(1); opacity: 0.45 } 100% { transform: scale(11); opacity: 0 } }
        @keyframes po-sm { 0% { transform: scale(1); opacity: 0.2 } 100% { transform: scale(13.9); opacity: 0 } }
        @keyframes pi-sm { 0% { transform: scale(1); opacity: 0.35 } 100% { transform: scale(8.8); opacity: 0 } }
      `}</style>
      {DOTS.map(({ cx, cy, r, size }, i) => (
        <g key={i}>
          <circle
            className={`pulse-outer pulse-outer-${size}`}
            cx={cx}
            cy={cy}
            r={r}
          />
          <circle
            className={`pulse-inner pulse-inner-${size}`}
            cx={cx}
            cy={cy}
            r={r}
          />
          <circle className="dot" cx={cx} cy={cy} r={r} />
        </g>
      ))}
    </svg>
  );
}

export function MapSection() {
  return (
    <section
      className="relative pt-[80px] tablet:pt-10 desktop:pt-0 bg-cover desktop:bg-contain bg-center bg-no-repeat desktop:bg-white"
      style={{
        backgroundImage:
          "url('https://vws-front-store.s3.ap-northeast-2.amazonaws.com/landing/map-background.webp')",
      }}
    >
      <div className="px-[16px] tablet:px-[32px] desktop:px-0 max-w-[1150px] mx-auto overflow-hidden flex flex-col desktop:flex-row">
        <div className="relative z-10 desktop:mt-[120px]">
          <h2 className="text-heading-1-mb desktop:text-heading-1 text-[#023059] text-center desktop:text-left">
            전국수임현황
          </h2>
          <div className="mt-5 flex flex-col items-center gap-2 desktop:gap-1 text-[#023059] desktop:items-start desktop:mt-6">
            <div className="flex flex-col items-center justify-center tablet:flex-row tablet:gap-4">
              <div className="text-3xl tablet:text-4xl desktop:text-5xl font-extralight mb-1 tablet:mb-0">
                시 / 군 / 구 지역수
              </div>
              <div className="flex items-center justify-center relative">
                <span className="text-5xl font-extrabold desktop:text-display-1">
                  130
                </span>
                <span className="text-heading-1-mb desktop:text-heading-1 desktop:absolute -top-2 -right-4">
                  +
                </span>
              </div>
            </div>
            <div className="flex flex-col items-center justify-center tablet:flex-row tablet:gap-4 tablet:mt-2 desktop:m-0">
              <div className="text-2xl font-light mb-1 tablet:mb-0 desktop:mb-4">
                서울특별시·경기도 외 전국지역
              </div>
              <div className="flex items-center justify-center gap-1">
                <span className="text-5xl font-extrabold desktop:text-display-1">
                  42
                </span>
                <span className="text-heading-1-mb desktop:font-bold desktop:text-[32px]">
                  %
                </span>
              </div>
            </div>
          </div>
          <div className="text-center mt-4 text-body-1 text-[#787882]">
            온라인 전국 법률서비스로 개인, 대기업, 사업자분들의 채권을 해결하고
            있습니다
          </div>
        </div>

        {/* 지도 + 점 애니메이션 */}
        <div className="relative mt-12 tablet:mt-6 desktop:mt-20 w-full max-w-[400px] tablet:max-w-[500px] desktop:max-w-[580px] mx-auto desktop:mx-0 mb-[80px] desktop:mb-40 scale-110">
          <img
            src="https://vws-front-store.s3.ap-northeast-2.amazonaws.com/landing/map.webp"
            alt="전국 수임 현황 지도"
            loading="lazy"
            decoding="async"
            className="w-full h-auto"
          />
          <MapDots />
        </div>
      </div>
    </section>
  );
}
